import { gql, useMutation } from '@apollo/client'

export const BATCH_CREATE_STORAGE_CONTAINERS = gql`
  mutation BatchCreateStorageContainers($input: BatchCreateStorageContainerInput!) {
    batchCreateStorageContainers(input: $input) {
      id
      container_id
      size
      type
      description
      is_active
      created_at
      updated_at
    }
  }
`

export const useBatchCreateStorageContainers = () => {
  return useMutation(BATCH_CREATE_STORAGE_CONTAINERS)
}
